module.exports = __webpack_public_path__ + "static/media/guaranties.5bcf36bb.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/guaranties.pdf
// module id = 283
// module chunks = 0